import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "14",
  viewBox: "0 0 18 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.6896 1.25868C15.9824 0.56566 14.84 0.556337 14.1341 1.25066L14.1081 1.27626C12.1657 3.19113 10.5257 4.89579 8.8522 6.61949C7.48735 8.02528 5.27403 8.13135 3.76789 6.87812L3.73631 6.85192C2.97539 6.22052 1.84121 6.32409 1.1963 7.0736C0.543412 7.83238 0.631889 8.98826 1.40223 9.62747L5.37043 12.9304C6.10096 13.5373 7.17352 13.4932 7.85056 12.8272C11.1443 9.58017 13.4846 6.99166 16.7027 3.81914C17.4153 3.11815 17.4035 1.95835 16.6896 1.25868Z",
      fill: "#75CCC2"
    }, null, -1)
  ])))
}
export default { render: render }